import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useAtom } from "jotai";
import { selectedUserIdAtom, openUserDialogAtom } from "../../atoms/usersTable";
import { selectedBookingIdAtom } from "../../atoms/bookingsTable";
import { getUserByProviderIdAtom } from "../../atoms/atoms";

export const ProviderCard = ({
    providerId,
    bookingId,
    userId,
    combinedName,
    providerPhoneNumber
}) => {
    const [, setSelectedBookingId] = useAtom(selectedBookingIdAtom);
    const [, setSelectedUserId] = useAtom(selectedUserIdAtom);
    const [, setOpenUserDialog] = useAtom(openUserDialogAtom);
    const [getUserById] = useAtom(getUserByProviderIdAtom);

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center"
            }}
        >
            <Typography
                sx={{
                    maxWidth: {
                        md: "150px",
                        lg: "230px"
                    },
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    pointerEvents: "auto !important",
                    fontWeight: 500,
                    color: "black",
                    textDecoration: "underline",
                    "&:hover": {
                        cursor: "pointer"
                    }
                }}
                variant="condensed"
                onClick={() => {
                    if (!providerId) return;
                    else if (!userId && providerId) {
                        const fetchedProvider = getUserById(providerId);
                        setSelectedUserId(fetchedProvider.id);
                    } else {
                        setSelectedUserId(userId);
                    }
                    setSelectedBookingId(bookingId);
                    setOpenUserDialog(true);
                }}
            >
                {combinedName}
            </Typography>
        </Box>
    );
};
